import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/* Router Modules */

export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index')
      }
    ],
    meta: { title: 'redirect' }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    hidden: true,
    meta: { title: '首页' }
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true,
    meta: { title: '登录' }
  },
  {
    path: '/invite',
    component: () => import('@/pages/invite/index'),
    hidden: true,
    meta: { title: '接受邀请' }
  },
  {
    path: '/home',
    component: () => import('@/views/home/index'),
    hidden: true,
    redirect: '/home/homePage',
    meta: { title: '首页' },
    children: [
      {
        path: 'homePage',
        component: () => import('@/views/home/homePage'),
        hidden: true,
        meta: { title: '首页' }
      },
      {
        path: 'matchCore',
        component: () => import('@/views/home/matchCore'),
        hidden: true,
        meta: { title: '赛事中心' }
      },
      {
        path: 'matchInfo',
        component: () => import('@/views/home/matchInfo'),
        hidden: true,
        meta: { title: '赛事详情' }
      },
      {
        name: 'application',
        path: 'application',
        component: () => import('@/views/home/application'),
        hidden: true,
        meta: { title: '报名' }
      }
    ]
  },
  {
    path: '/homeIndex',
    component: Layout,
    redirect: '/homeIndex/dashboard',
    meta: { title: '首页', icon: 'icon-home-21' },
    children: [
      {
        path: 'dashboard',
        component: () => import('@/pages/home/index'),
        name: 'Dashboard',
        meta: { title: '工作台' }
      }
    ]
  },
  {
    path: '/myTeam',
    component: Layout,
    redirect: '/myTeam/myTeamIndex',
    meta: { title: '我的队伍', icon: 'icon-people' },
    children: [
      {
        path: 'myTeamIndex',
        component: () => import('@/pages/myTeam/index'),
        name: 'MyTeamIndex',
        meta: { title: '列表', icon: 'icon-shouye' }
      }
    ]
  },
  {
    path: '/information',
    component: Layout,
    redirect: '/information/informationIndex',
    meta: { title: '站内信', icon: 'icon-device-message1' },
    children: [
      {
        path: 'informationIndex',
        component: () => import('@/pages/information/index'),
        name: 'InformationIndex',
        meta: { title: '列表', icon: 'icon-note' }
      },
      {
        path: 'informationInfo',
        hidden: true,
        component: () => import('@/pages/information/info'),
        name: 'InformationInfo',
        meta: { title: '详情', activeMenu: '/information/informationIndex', icon: 'icon-shouye' }
      }
    ]
  },
  {
    path: '/identity',
    component: Layout,
    redirect: '/identity/identityIndex',
    meta: { title: '身份认证', icon: 'icon-user-octagon' },
    children: [
      {
        path: 'identityIndex',
        component: () => import('@/pages/identity/index'),
        name: 'IdentityIndex',
        meta: { title: '认证中心', icon: 'icon-shouye' }
      }
    ]
  },
  {
    path: '/record',
    component: Layout,
    redirect: '/record/recordIndex',
    meta: { title: '参赛记录', icon: 'icon-note' },
    children: [
      {
        path: 'recordIndex',
        component: () => import('@/pages/record/index'),
        name: 'RecordIndex',
        meta: { title: '列表', icon: 'icon-shouye' }
      }
    ]
  },
  {
    path: '/user',
    component: Layout,
    redirect: '/user/userIndex',
    meta: { title: '人员管理', icon: 'icon-user-edit1' },
    children: [
      {
        path: 'userIndex',
        component: () => import('@/pages/user/index'),
        name: 'UserIndex',
        // hidden: true,
        meta: { title: '列表', icon: 'icon-shouye' }
      },
      {
        path: 'joinTeam',
        component: () => import('@/pages/user/JoinTeam'),
        name: 'JoinTeam',
        hidden: true,
        meta: { title: '入队管理', activeMenu: '/user/userIndex', icon: 'icon-shouye' }
      },
      {
        path: 'score',
        component: () => import('@/pages/user/score'),
        name: 'Score',
        hidden: true,
        meta: { title: '查看成绩', activeMenu: '/user/userIndex', icon: 'icon-shouye' }
      }
    ]
  },
  {
    path: '/auth-redirect',
    component: () => import('@/views/login/auth-redirect'),
    hidden: true,
    meta: { title: 'auth-redirect' }
  },
  {
    path: '/honor',
    component: Layout,
    redirect: '/honor/honorIndex',
    meta: { title: '荣誉中心', icon: 'icon-award' },
    children: [
      {
        path: 'honorIndex',
        component: () => import('@/pages/honor/index'),
        name: 'HonorIndex',
        meta: { title: '荣誉列表', icon: 'icon-shouye' }
      }
    ]
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true,
    meta: { title: '404' }
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true,
    meta: { title: '401' }
  }
]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [
  // { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  })

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}
router.beforeEach((to, from, next) => {
  // 设置延时器让created先执行在进行路由跳转
  if (from.name) {
    store.commit('tagsView/ADD_CACHED_VIEW', to)
  }
  next()
})
export default router
